import React, { useRef, useEffect } from 'react';
import YouTube from 'react-youtube';

const VideoSection = ({ onPlayerReady,url }) => {
  const playerRef = useRef(null);
  
  const extractYoutubeId = (url) => {
    if (url?.length < 1 || !url) {
      return '';
    }
    const regExp = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|shorts\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
    const checkMatch = url?.match(regExp);
    return checkMatch?.length > 0 ? checkMatch[1] : '';
  };

  const handleReady = (event) => {
    playerRef.current = event.target;
    
    if (onPlayerReady) {
      onPlayerReady(event.target);
    }
  };

  useEffect(() => {
    return () => {
      playerRef.current = null;
    };
  }, []);

  return (
    <section className="xl:py-4">
      <YouTube
        videoId={extractYoutubeId(`${url}`)}
        className="aspect-video overflow-hidden max-w-7xl mx-auto md:max-w-3xl"
        opts={{
          height: '100%',
          width: '100%',
          playerVars: {
            autoplay: 0,
            mute: 0,
            controls: 1,
            playsinline: 1,
            rel: 0,
            showinfo: 1,
          }
        }}
        onReady={handleReady}
      />
    </section>
  );
};

export default VideoSection;